import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Entity } from '../../models/entity';

@Component({
  selector: 'ngx-entity-selector',
  templateUrl: './entity-selector.component.html',
  styleUrls: ['./entity-selector.component.scss'],
})
export class EntitySelectorComponent implements OnInit {
  @Input()
  public entities: Array<Entity> = [];
  public selectableEntities: Array<Entity> = [];
  @Input()
  public selectedEntities: Array<Entity> = [];

  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();
  @Output() onContinue: EventEmitter<Array<Entity>> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {
    this.selectableEntities = this.entities.slice(0);
  }

  selectChild(i, child) {
    this.selectedEntities.push(child);
    this.selectableEntities.splice(i, 1);
    this.sort();
  }

  selectAll() {
    for ( const entity of this.selectableEntities ) {
      this.selectedEntities.push(entity);
    }
    this.selectableEntities = [];
    this.sort();
  }

  unselectAll() {
    this.selectableEntities = this.entities.slice(0);
    this.selectedEntities = [];
    this.sort();
  }

  unselectChild(i, child) {
    this.selectableEntities.push(child);
    this.selectedEntities.splice(i, 1);
    this.sort();
  }

  sort() {
    this.selectableEntities.sort((n1, n2) => {
      return this.naturalCompare(n1['entityable'].first_name, n2['entityable'].first_name);
    })

    this.selectableEntities.sort((n1, n2) => {
      return this.naturalCompare(n1['entityable'].first_name, n2['entityable'].first_name);
    })
  }

  triggerCancel() {
    this.onCancel.emit(true);
  }

  triggerContinue() {
    this.onContinue.emit(this.selectedEntities);
  }

  naturalCompare(a, b) {
    const ax = [], bx = [];

    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      ax.push([$1 || Infinity, $2 || ''])
    });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      bx.push([$1 || Infinity, $2 || ''])
    });

    while (ax.length && bx.length) {
      const an = ax.shift();
      const bn = bx.shift();
      const nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }

    return ax.length - bx.length;
  }
}
